import React, { Component, useState, useEffect } from 'react';
import {
    Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink,
    UncontrolledDropdown,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import './NavMenu.css';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

import { faUser, faHeart, faStar, faTrashCan, faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { faUser as faUserSolid, faCamera, faMagnifyingGlass, faSpinner, faFileInvoice, faUsersLine, faBan, faBook, faFloppyDisk, faCashRegister } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DarkModeDropdown from './DarkModeDropdown';
import WelcomeName from "./WelcomeName";

export const NavMenu = () => {
    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const navigate = useNavigate();

    const [collapsed, setCollapsed] = useState(true);

    const toggleNavbar = () => {
        setCollapsed(!collapsed)
    }
    const handleLogin = () => {
        instance.loginRedirect(loginRequest);
    }
    const handleLogout = () => {
        instance.logoutRedirect();
    }

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3 py-0" container style={{ backgroundColor: '#1295d8' }}>
                <NavbarBrand tag={Link} to="/">
                    <img src="/assets/images/hyetech_logo2_4color.png" alt="HyeTech" height="75" />
                    <span className="ms-3 mt-3 h3" style={{ lineHeight: '75px' }}><span className="d-none d-sm-inline">HyeTech </span>Events Admin</span>
                    {/*https://s3.us-east-1.amazonaws.com/tw-desk/i/359076/doccontent/ec0badbd-336e-477b-b36d-ec96f4dffb61.png*/}
                    {/*https://hyetechnetworks.com/wp-content/uploads/2021/09/hyetech_logo2_4color.png*/}
                </NavbarBrand>
                <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                    {/*<ul className="navbar-nav flex-grow">*/}
                    <Nav navbar>
                        <NavItem>
                            <NavLink tag={Link} to="/">Home</NavLink>
                        </NavItem>
                        {isAuthenticated ?
                            <>
                                <NavItem>
                                    <NavLink tag={Link} to="/events">Events</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} to="/logout" onClick={handleLogout}>
                                        <WelcomeName /> (Logout)
                                    </NavLink>
                                </NavItem>
                            </>
                            : (inProgress !== InteractionStatus.Startup && inProgress !== InteractionStatus.HandleRedirect) ?
                                <NavItem>
                                    <NavLink tag={Link} to="/login" onClick={handleLogin}>Login</NavLink>
                                </NavItem>
                                : null}
                        {/*<UncontrolledDropdown nav>*/}
                        {/*    <DropdownToggle nav caret>*/}
                        {/*        {authUser ?*/}
                        {/*            <>*/}
                        {/*                <FontAwesomeIcon icon={faUserSolid} />*/}
                        {/*            </>*/}
                        {/*            :*/}
                        {/*            <>*/}
                        {/*                <FontAwesomeIcon icon={faUser} />*/}
                        {/*            </>*/}
                        {/*        }*/}
                        {/*    </DropdownToggle>*/}
                        {/*    <DropdownMenu flip tag="ul">*/}
                        {/*        {authUser ?*/}
                        {/*            <>*/}
                        {/*                <DropdownItem text tag="li">Welcome{authUser.profile && authUser.profile.firstName ? ', ' + authUser.profile.firstName : '!'}</DropdownItem>*/}
                        {/*                <DropdownItem divider tag="li" />*/}
                        {/*                <DropdownItem tag={Link} to="/profile">Profile</DropdownItem>*/}
                        {/*                <DropdownItem divider tag="li" />*/}
                        {/*                {profileStudents && profileStudents.length > 0*/}
                        {/*                    ?*/}
                        {/*                    <>*/}
                        {/*                        {profileStudents.map((s, i) => { return <DropdownItem tag="li" key={"nav-student-" + s.studentId} >{s.firstName} {s.lastName}</DropdownItem> })}*/}
                        {/*                        <DropdownItem divider tag="li" />*/}
                        {/*                    </>*/}
                        {/*                    :*/}
                        {/*                    null*/}
                        {/*                }*/}
                        {/*                <DropdownItem tag="li" onClick={handleLogout}>Log Out</DropdownItem>*/}
                        {/*            </>*/}
                        {/*            :*/}
                        {/*            <>*/}
                        {/*                <DropdownItem tag={Link} to="/profile/register" >Register</DropdownItem>*/}
                        {/*                <DropdownItem divider tag="li" />*/}
                        {/*                <DropdownItem tag={Link} to="/login" >Log In</DropdownItem>*/}
                        {/*            </>*/}
                        {/*        }*/}
                        {/*    </DropdownMenu>*/}
                        {/*</UncontrolledDropdown>*/}
                        {/*<DarkModeDropdown />*/}
                    </Nav>
                </Collapse>
            </Navbar>
        </header>
        );
}
